// 16-цветная палитра графиков. Первым идёт фирменный красный WML,
// остальные — приглушённые оттенки одной светлоты (подобраны в OKLCH),
// различимые и на тёмном #161826, и в светлой теме.
export const PALETTE = [
  '#ee525a', // WML red (brand accent)
  '#7fa3e3', // blue
  '#7ec9b0', // mint
  '#d9c284', // sand
  '#d98a84', // coral
  '#84c4d9', // cyan
  '#d284c9', // orchid
  '#8f9ce6', // indigo
  '#c2cc7a', // olive
  '#7ed0cd', // teal
  '#dda87e', // apricot
  '#a6b4ec', // periwinkle
  '#b795e0', // lilac
  '#93d68f', // sage
  '#d993c9', // rose
  '#9aa3b8', // slate
];

/**
 * Детерминированный цвет по accountId — не сдвигается когда что-то скрыто/показано.
 * Простой FNV-1a-подобный хэш → индекс в PALETTE.
 */
export function colorForAccount(accountId: string): string {
  let h = 2166136261;
  for (let i = 0; i < accountId.length; i++) {
    h ^= accountId.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  const idx = Math.abs(h) % PALETTE.length;
  return PALETTE[idx]!;
}
